import { all, call, put, takeLatest } from 'redux-saga/effects';
import FunctionUtils from 'utils/FunctionUtils';
import { TeacherHttp } from '../services/teacher.http';
import { actions } from './slice';

const teacherHttp = new TeacherHttp();

export function* getListTeacher(api, action) {
  const response = yield call(api.getListTeacher, action.payload);

  try {
    if (response.ok) {
      yield put(actions.getListTeacherSuccess(response.data.data));
    } else {
      yield put(actions.getListTeacherFail(response.data));
    }
  } catch (error) {
    yield put(actions.getListTeacherFail(error));
  }
}
export function* getListTeacherPgd(api, action) {
  const response = yield call(api.getListTeacherPgd, action.payload);

  try {
    if (response.ok) {
      yield put(actions.getListTeacherPgdSuccess(response.data.data));
    } else {
      yield put(actions.getListTeacherPgdFail(response.data));
    }
  } catch (error) {
    yield put(actions.getListTeacherPgdFail(error));
  }
}
export function* getListSubjects(api, action) {
  const response = yield call(api.getListSubjects, action.payload);

  try {
    if (response.ok) {
      yield put(actions.getListSubjectsSuccess(response.data.data));
    } else {
      yield put(actions.getListSubjectsFail(response.data));
    }
  } catch (error) {
    yield put(actions.getListSubjectsFail(error));
  }
}
export function* removeTeacher(api, action) {
  const response = yield call(api.removeTeacher, action.payload);

  try {
    if (response.ok) {
      yield put(actions.removeTeacherSuccess(response.data.data));
    } else {
      yield put(actions.removeTeacherFail(response.data));
    }
  } catch (error) {
    yield put(actions.removeTeacherFail(error));
  }
}
export function* addTeacher(api, action) {
  const response = yield call(api.addTeacher, action.payload);

  try {
    if (response.ok) {
      yield put(actions.addTeacherSuccess(response.data.data));
    } else {
      yield put(actions.addTeacherFail(response.data));
    }
  } catch (error) {
    yield put(actions.addTeacherFail(error));
  }
}
export function* editTeacher(api, action) {
  const response = yield call(api.editTeacher, action.payload);

  try {
    if (response.ok) {
      yield put(actions.editTeacherSuccess(response.data.data));
    } else {
      yield put(actions.editTeacherFail(response.data));
    }
  } catch (error) {
    yield put(actions.editTeacherFail(error));
  }
}
export function* resetPassword(api, action) {
  const response = yield call(api.resetPassword, action.payload);

  try {
    if (response.ok) {
      yield put(actions.resetPasswordSuccess(response.data.data));
    } else {
      yield put(actions.resetPasswordFail(response.data));
    }
  } catch (error) {
    yield put(actions.resetPasswordFail(error));
  }
}
export function* changeSubject(api, action) {
  const response = yield call(api.changeSubject, action.payload);

  try {
    if (response.ok) {
      yield put(actions.changeSubjectSuccess(response.data.data));
    } else {
      yield put(actions.changeSubjectFail(response.data));
    }
  } catch (error) {
    yield put(actions.changeSubjectFail(error));
  }
}
export function* roleTeacher(api, action) {
  const response = yield call(api.roleTeacher, action.payload);

  try {
    if (response.ok) {
      yield put(actions.roleTeacherSuccess(response.data.data));
    } else {
      yield put(actions.roleTeacherFail(response.data));
    }
  } catch (error) {
    yield put(actions.roleTeacherFail(error));
  }
}

export function* TeacherSaga() {
  yield all([
    yield takeLatest(actions.getListTeacher.type, getListTeacher, teacherHttp),
    yield takeLatest(actions.getListTeacherPgd.type, getListTeacherPgd, teacherHttp),
    yield takeLatest(actions.getListSubjects.type, getListSubjects, teacherHttp),
    yield takeLatest(actions.removeTeacher.type, removeTeacher, teacherHttp),
    yield takeLatest(actions.addTeacher.type, addTeacher, teacherHttp),
    yield takeLatest(actions.editTeacher.type, editTeacher, teacherHttp),
    yield takeLatest(actions.resetPassword.type, resetPassword, teacherHttp),
    yield takeLatest(actions.changeSubject.type, changeSubject, teacherHttp),
    yield takeLatest(actions.roleTeacher.type, roleTeacher, teacherHttp)
  ]);
}
